import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { useAppSelector } from '../hook';
import { ICoin } from 'src/types/coins';

export type CoinsState = {
    coins: ICoin[];
};

const initialState: CoinsState = {
    coins: [],
};

export const coinsSlice = createSlice({
    name: 'coins',
    initialState,
    reducers: {
        setCoins: (state, action: PayloadAction<ICoin[]>) => {
            state.coins = action.payload;
        },
    },
});

export const { setCoins } = coinsSlice.actions;
export const getCoinsState = (state: RootState) => state.coins;
export const useCoinsState = () => useAppSelector(getCoinsState);

export default coinsSlice.reducer;
